


import { Component, Vue } from 'vue-property-decorator';
import { ResponsiveImageMedia } from '../../../../components/utils/ResponsiveImage/ResponsiveImage.models';
import ResponsiveImage from '../../../../components/utils/ResponsiveImage/index.vue';

@Component({
  components: { ResponsiveImage }
})
export default class ImageCollage extends Vue {
  private collageImages: string[] = [
    require('@/assets/images/contact/04.jpg'),
    require('@/assets/images/contact/02.jpg'),
    require('@/assets/images/contact/03.jpg'),
    require('@/assets/images/contact/01.jpg')
  ];

  private getResponsiveMedia(img: string): ResponsiveImageMedia {
    return {
      MQ1: img,
      MQ2: img,
      MQ3: img,
      MQ4: img,
      MQ5: img,
      MQ6: img
    };
  }
}
